const expandSectionsWithInvalidInputs = () => {
    let errorBlocks = document.querySelectorAll('.form-group.is-invalid');
    errorBlocks.forEach(function(element) {
        if (!element.closest('.hide') && !element.closest('[hidden]')) {
            expandSection(element);
        }
    });
}

function expandSection(element) {
    let collapse = element.closest('.collapse');
    if (!collapse) {
        return;
    }
    let children = collapse.parentElement.children;

    for (let i = 0; i < children.length; i++) {
        if (children[i].classList.contains('collapsed')) {
            children[i].classList.remove('collapsed');
            children[i].setAttribute('aria-expanded', 'true');

            collapse.classList.add('in');
            collapse.setAttribute('aria-expanded', 'true');
            collapse.setAttribute('style', '');
            break;
        }
    }
}

export default expandSectionsWithInvalidInputs;
